import React from 'react';
import ContactImg from '../assets/ContactImg.png';
import styled, { css, keyframes } from 'styled-components';

interface LIProps {
  orbit: boolean;
}

const LeftImage: React.FC<LIProps> = ({ orbit }) => {
  return (
    <LeftWrapper $orbit={orbit}>
      <Image src={ContactImg} />
      <Circles>
        <BigCircle />
        <OrbitWrapper $orbit={orbit} $delay='0s' $radius={250} $startAngle={300}>
          <SmallCircle $radius={290} $color='#05c793' $size={78} />
        </OrbitWrapper>
        <OrbitWrapper $orbit={orbit} $delay='0s' $radius={180} $startAngle={317}>
          <SmallCircle $radius={300} $color='#283288' $size={157} />
        </OrbitWrapper>
      </Circles>
    </LeftWrapper>
  );
};

export default LeftImage;

const LeftWrapper = styled.div<{
  $orbit: boolean;
}>`
  justify-content: center;
  width: 40%;
  height: 100%;
  display: ${({ $orbit }) => ($orbit ? 'none' : '')};

  @media (min-width: 1024px) {
    display: flex;
    width: 40%;
  }
`;

const Circles = styled.div`
  position: relative;
  width: 100%;
`;

const BigCircle = styled.div`
  width: ${539 * 0.75}px;
  height: ${539 * 0.75}px;
  background: #ceddff;
  border-radius: 50%;
  position: absolute;
  top: ${40 * 0.75}%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

const OrbitWrapper = styled.div<{
  $orbit: boolean;
  $delay: string;
  $radius: number;
  $startAngle: number;
}>`
  position: absolute;
  top: ${40 * 0.75}%;
  left: 50%;
  width: 0;
  height: 0;
  transform-origin: center;

  transform: rotate(${({ $startAngle }) => $startAngle}deg);

  ${({ $orbit, $startAngle, $delay }) =>
    $orbit &&
    css`
      animation: ${keyframes`
        0% { transform: rotate(${$startAngle}deg); }
        100% { transform: rotate(${$startAngle - 70}deg); }
      `} 0.5s cubic-bezier(0.4, 0, 0.2, 1) forwards;
      animation-delay: ${$delay};
    `}
`;

const SmallCircle = styled.div<{ $radius: number; $color: string; $size: number }>`
  position: absolute;
  width: ${({ $size }) => $size * 0.75}px;
  height: ${({ $size }) => $size * 0.75}px;
  background: ${({ $color }) => $color};
  border-radius: 50%;
  top: 0;
  left: ${({ $radius }) => $radius * 0.75}px;
`;

const Image = styled.img`
  position: absolute;
  bottom: 0;
  z-index: 2;
  width: calc(${449 * 0.75}px);
`;
